import { luigiMediaArray } from './luigiMedia'
import { luigiBio } from './luigiBios'

import { frodoReviewerReviewHinge, hollyReviewerReviewBumble, gatsbyReviewerReviewTinder } from './luigiReviewerReviews'
import { frodoReviewerProfile, hollyReviewerProfile, gatsbyReviewerProfile } from './luigiReviewers'

export const frodoProfileReviewHinge = {
  _id: 'frodoProfileReviewHingeId',
  userId: 'luigiUserId',
  userEmail: 'luigi@email.com',
  datingProfileId: 'luigiDatingProfileHingeId',
  reviewerProfileId: 'frodoReviewerProfileId',
  reviewerEmail: 'frodo@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: luigiMediaArray[1]._id,
      mediaItemURL: luigiMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[1].type,
      caption: luigiMediaArray[1].captions[0],
      subcaption: luigiMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[6]._id,
      mediaItemURL: luigiMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[6].type,
      caption: luigiMediaArray[6].captions[0],
      subcaption: luigiMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[4]._id,
      mediaItemURL: luigiMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[4].type,
      caption: luigiMediaArray[4].captions[0],
      subcaption: luigiMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[18]._id,
      mediaItemURL: luigiMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[18].type,
      caption: luigiMediaArray[18].captions[0],
      subcaption: luigiMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[25]._id,
      mediaItemURL: luigiMediaArray[25].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[25].type,
      caption: luigiMediaArray[25].captions[0],
      subcaption: luigiMediaArray[25].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[12]._id,
      mediaItemURL: luigiMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[12].type,
      caption: luigiMediaArray[12].captions[0],
      subcaption: luigiMediaArray[12].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Great smile! You look sharp in the suit! Good start!`,
      verdict: 'Very',
    },
    {
      feedback: `Good friend pic! Great social proof! You look good!`,
      verdict: 'Yes',
    },
    {
      feedback: `Wow you look super hot here. Bad boy energy. Are you actually a felon?`,
      verdict: 'Yes',
    },
    {
      feedback: `Uh... did you kill someone?`,
      verdict: 'No',
    },
    {
      feedback: `A grainy photo of you eating a hashbrown? What?`,
      verdict: 'No',
    },
    {
      feedback: `You look good! (Even if you're on trial for murder)`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: luigiBio._id,
    vitalInfo: { ...luigiBio.vitalInfo },
    prompts: [
      { ...luigiBio.prompts[0] },
      { ...luigiBio.prompts[1] },
      { ...luigiBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Wow an Ivy League grad!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Maybe a bit too intense for this setting`,
        verdict: 'No', 
      },
      {
        feedback: `Intriguing... and too accurate considering the circumstances...`,
        verdict: 'No', 
      },
      {
        feedback: `OK, this shows you're a serious thinker, which could attract other serious thinkers but isn't for everyone`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Luigi is a smart and attractive guy with a wonderful smile but it appears he has a double personality because he seems to be on trial for murder`,
    good: `Your smile and your educational background!`,
    notGood: `The fact that you killed someone, and also the intensity of the prompt responses`,
    verdict: `Overall you're an attractive guy with a lot of potential, but there are significant dealbreakers on your profile such that you'll only appeal to women who are attracted by bad boys. Still it'll be tough to hide the fact that you're on trial for murder, so maybe this is the best way to go about it`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...frodoReviewerReviewHinge },
  reviewerProfile: { ...frodoReviewerProfile },
  bioItems: { ...luigiBio },
  mediaItems: [ ...luigiMediaArray ],
}

export const hollyProfileReviewBumble = {
  _id: 'hollyProfileReviewBumbleId',
  userId: 'luigiUserId',
  userEmail: 'luigi@email.com',
  datingProfileId: 'luigiDatingProfileBumbleId',
  reviewerProfileId: 'hollyReviewerProfileId',
  reviewerEmail: 'holly@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: luigiMediaArray[1]._id,
      mediaItemURL: luigiMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[1].type,
      caption: luigiMediaArray[1].captions[0],
      subcaption: luigiMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[6]._id,
      mediaItemURL: luigiMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[6].type,
      caption: luigiMediaArray[6].captions[0],
      subcaption: luigiMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[4]._id,
      mediaItemURL: luigiMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[4].type,
      caption: luigiMediaArray[4].captions[0],
      subcaption: luigiMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[18]._id,
      mediaItemURL: luigiMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[18].type,
      caption: luigiMediaArray[18].captions[0],
      subcaption: luigiMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[25]._id,
      mediaItemURL: luigiMediaArray[25].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[25].type,
      caption: luigiMediaArray[25].captions[0],
      subcaption: luigiMediaArray[25].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[12]._id,
      mediaItemURL: luigiMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[12].type,
      caption: luigiMediaArray[12].captions[0],
      subcaption: luigiMediaArray[12].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Great smile! You look sharp in the suit! Good start!`,
      verdict: 'Very',
    },
    {
      feedback: `Good friend pic! Great social proof! You look good!`,
      verdict: 'Yes',
    },
    {
      feedback: `Wow you look super hot here. Bad boy energy. Are you actually a felon?`,
      verdict: 'Yes',
    },
    {
      feedback: `Uh... did you kill someone?`,
      verdict: 'No',
    },
    {
      feedback: `A grainy photo of you eating a hashbrown? What?`,
      verdict: 'No',
    },
    {
      feedback: `You look good! (Even if you're on trial for murder)`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: luigiBio._id,
    vitalInfo: { ...luigiBio.vitalInfo },
    prompts: [
      { ...luigiBio.prompts[0] },
      { ...luigiBio.prompts[1] },
      { ...luigiBio.prompts[2] }
    ],
    aboutMe: luigiBio.aboutMe[0],
    hobbies: [luigiBio.hobbies[0], luigiBio.hobbies[1], luigiBio.hobbies[2], luigiBio.hobbies[3], luigiBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Wow an Ivy League grad!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Maybe a bit too intense for this setting`,
        verdict: 'No', 
      },
      {
        feedback: `Intriguing... and too accurate considering the circumstances...`,
        verdict: 'No', 
      },
      {
        feedback: `OK, this shows you're a serious thinker, which could attract other serious thinkers but isn't for everyone`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Luigi is a smart and attractive guy with a wonderful smile but it appears he has a double personality because he seems to be on trial for murder`,
    good: `Your smile and your educational background!`,
    notGood: `The fact that you killed someone, and also the intensity of the prompt responses`,
    verdict: `Overall you're an attractive guy with a lot of potential, but there are significant dealbreakers on your profile such that you'll only appeal to women who are attracted by bad boys. Still it'll be tough to hide the fact that you're on trial for murder, so maybe this is the best way to go about it`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...hollyReviewerReviewBumble },
  reviewerProfile: { ...hollyReviewerProfile },
  bioItems: { ...luigiBio },
  mediaItems: [ ...luigiMediaArray ],
}

export const gatsbyProfileReviewTinder = {
  _id: 'gatsbyProfileReviewTinderId',
  userId: 'luigiUserId',
  userEmail: 'luigi@email.com',
  datingProfileId: 'luigiDatingProfileTinderId',
  reviewerProfileId: 'gatsbyReviewerProfileId',
  reviewerEmail: 'gatsby@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: luigiMediaArray[1]._id,
      mediaItemURL: luigiMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[1].type,
      caption: luigiMediaArray[1].captions[0],
      subcaption: luigiMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[6]._id,
      mediaItemURL: luigiMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[6].type,
      caption: luigiMediaArray[6].captions[0],
      subcaption: luigiMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[4]._id,
      mediaItemURL: luigiMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[4].type,
      caption: luigiMediaArray[4].captions[0],
      subcaption: luigiMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[18]._id,
      mediaItemURL: luigiMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[18].type,
      caption: luigiMediaArray[18].captions[0],
      subcaption: luigiMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[25]._id,
      mediaItemURL: luigiMediaArray[25].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[25].type,
      caption: luigiMediaArray[25].captions[0],
      subcaption: luigiMediaArray[25].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[12]._id,
      mediaItemURL: luigiMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[12].type,
      caption: luigiMediaArray[12].captions[0],
      subcaption: luigiMediaArray[12].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Great smile! You look sharp in the suit! Good start!`,
      verdict: 'Very',
    },
    {
      feedback: `Good friend pic! Great social proof! You look good!`,
      verdict: 'Yes',
    },
    {
      feedback: `Wow you look super hot here. Bad boy energy. Are you actually a felon?`,
      verdict: 'Yes',
    },
    {
      feedback: `Uh... did you kill someone?`,
      verdict: 'No',
    },
    {
      feedback: `A grainy photo of you eating a hashbrown? What?`,
      verdict: 'No',
    },
    {
      feedback: `You look good! (Even if you're on trial for murder)`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: luigiBio._id,
    vitalInfo: { ...luigiBio.vitalInfo },
    prompts: [
      { ...luigiBio.prompts[0] },
      { ...luigiBio.prompts[1] },
      { ...luigiBio.prompts[2] }
    ],
    aboutMe: luigiBio.aboutMe[0],
    hobbies: [luigiBio.hobbies[0], luigiBio.hobbies[1], luigiBio.hobbies[2], luigiBio.hobbies[3], luigiBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Wow an Ivy League grad!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Maybe a bit too intense for this setting`,
        verdict: 'No', 
      },
      {
        feedback: `Intriguing... and too accurate considering the circumstances...`,
        verdict: 'No', 
      },
      {
        feedback: `OK, this shows you're a serious thinker, which could attract other serious thinkers but isn't for everyone`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Luigi is a smart and attractive guy with a wonderful smile but it appears he has a double personality because he seems to be on trial for murder`,
    good: `Your smile and your educational background!`,
    notGood: `The fact that you killed someone, and also the intensity of the prompt responses`,
    verdict: `Overall you're an attractive guy with a lot of potential, but there are significant dealbreakers on your profile such that you'll only appeal to women who are attracted by bad boys. Still it'll be tough to hide the fact that you're on trial for murder, so maybe this is the best way to go about it`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...gatsbyReviewerReviewTinder },
  reviewerProfile: { ...gatsbyReviewerProfile },
  bioItems: { ...luigiBio },
  mediaItems: [ ...luigiMediaArray ],
}